(function () {
  'use strict';

  const STORAGE_KEY = 'pl_autoship_pending_conversions';

  /* ── Analytics helper ── */
  function plTrack(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });
  }

  /* ── Scroll shadow updater ── */
  function updateScrollShadows(row) {
    const wrapper = row.closest('.pl-autoship-upsell__freq-wrapper');
    if (!wrapper) return;
    const scrollLeft = row.scrollLeft;
    const maxScroll = row.scrollWidth - row.clientWidth;
    wrapper.classList.toggle('can-scroll-left', scrollLeft > 2);
    wrapper.classList.toggle('can-scroll-right', maxScroll > 2 && scrollLeft < maxScroll - 2);
  }

  function initFreqRow(row) {
    if (row.dataset.scrollInit) return;
    row.dataset.scrollInit = 'true';
    updateScrollShadows(row);
    row.addEventListener('scroll', () => updateScrollShadows(row), { passive: true });
  }

  /* ── Open / close frequency panel ── */
  function openPanel(upsell) {
    const panel = upsell.querySelector('.pl-autoship-upsell__panel');
    if (!panel) return;
    panel.classList.add('is-open');
    requestAnimationFrame(() => {
      const row = panel.querySelector('.pl-autoship-upsell__freq-row');
      if (row) {
        initFreqRow(row);
        updateScrollShadows(row);
      }
    });
  }

  function closePanel(upsell) {
    const panel = upsell.querySelector('.pl-autoship-upsell__panel');
    if (panel) panel.classList.remove('is-open');
  }

  /* ── Set mode ── */
  function setMode(upsell, mode) {
    const subBtn = upsell.querySelector('.pl-autoship-upsell__toggle-btn--sub');

    if (mode === 'sub') {
      subBtn.classList.add('is-active');
      subBtn.setAttribute('aria-pressed', 'true');
      openPanel(upsell);

      plTrack('pl_autoship_open', {
        item_key: upsell.dataset.itemKey,
        variant_id: upsell.dataset.variantId,
      });
    } else {
      subBtn.classList.remove('is-active');
      subBtn.setAttribute('aria-pressed', 'false');
      closePanel(upsell);

      const success = upsell.querySelector('.pl-autoship-upsell__success');
      if (success) success.hidden = true;

      plTrack('pl_autoship_dismissed', {
        item_key: upsell.dataset.itemKey,
        variant_id: upsell.dataset.variantId,
      });
    }
  }

  /* ── Build the rich payload used for cart-upgrade + post-checkout match ── */
  function buildUpsellPayload(upsell, selectedBtn) {
    const oneTime = parseFloat(upsell.dataset.oneTimePrice) || 0;
    const subPrice = parseFloat(selectedBtn.dataset.price) || 0;
    const compareAt = parseFloat(selectedBtn.dataset.compareAt) || 0;
    const planName = selectedBtn.dataset.sellingPlanName
      || selectedBtn.querySelector('.pl-autoship-upsell__freq-name')?.textContent.trim()
      || '';

    const freqMatch = planName.match(/(\d+)\s*(day|week|month)/i);
    const frequencyValue = freqMatch ? parseInt(freqMatch[1], 10) : null;
    const frequencyUnit = freqMatch ? freqMatch[2].toLowerCase() : null;

    return {
      surface: 'cart_drawer',
      component: 'pl-cart-autoship-upsell',
      variant_id: parseInt(upsell.dataset.variantId, 10),
      product_id: parseInt(upsell.dataset.productId, 10),
      product_title: upsell.dataset.productTitle || '',
      variant_title: upsell.dataset.variantTitle || '',
      selling_plan_id: parseInt(selectedBtn.dataset.sellingPlanId, 10),
      selling_plan_name: planName,
      frequency_value: frequencyValue,
      frequency_unit: frequencyUnit,
      discount_percentage: parseInt(selectedBtn.dataset.discountPct, 10) || 0,
      one_time_price: oneTime,
      subscription_price: subPrice,
      savings: +(compareAt - subPrice).toFixed(2),
      currency: upsell.dataset.currency || 'USD',
      line_index: parseInt(upsell.dataset.lineIndex, 10) || null,
      quantity: parseInt(upsell.dataset.itemQty, 10) || 1
    };
  }

  /* ── Flag pending conversion for post-checkout match ── */
  function flagPendingConversion(payload) {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      const pending = raw ? JSON.parse(raw) : {};
      pending[payload.selling_plan_id] = { ...payload, flagged_at: Date.now() };
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pending));
    } catch (err) {
      console.warn('[PL Autoship] could not flag pending conversion', err);
    }
  }

  /* ── Main delegated click handler ── */
function handleClick(e) {
  const target = e.target.closest(
    '.pl-autoship-upsell__toggle-btn--sub, ' +
    '.pl-autoship-upsell__freq-btn, ' +
    '.pl-autoship-upsell__confirm, ' +
    '.pl-autoship-upsell__cancel'
  );

  if (!target) return;
    /* Autoship toggle button */
    const subBtn = e.target.closest('.pl-autoship-upsell__toggle-btn--sub');
    if (subBtn) {
      const upsell = subBtn.closest('.pl-autoship-upsell');
      const isActive = subBtn.classList.contains('is-active');
      setMode(upsell, isActive ? 'onetime' : 'sub');
      return;
    }

    /* Frequency button selection */
    const freqBtn = e.target.closest('.pl-autoship-upsell__freq-btn');
    if (freqBtn) {
      const upsell = freqBtn.closest('.pl-autoship-upsell');
      upsell.querySelectorAll('.pl-autoship-upsell__freq-btn').forEach((btn) => {
        btn.classList.remove('is-selected');
        btn.setAttribute('aria-pressed', 'false');
      });
      freqBtn.classList.add('is-selected');
      freqBtn.setAttribute('aria-pressed', 'true');

      plTrack('pl_autoship_frequency_selected', {
        item_key: upsell.dataset.itemKey,
        selling_plan_id: freqBtn.dataset.sellingPlanId,
        selling_plan_name: freqBtn.querySelector('.pl-autoship-upsell__freq-name')?.textContent.trim(),
      });
      return;
    }

    /* Confirm button */
    const confirmBtn = e.target.closest('.pl-autoship-upsell__confirm');
    if (confirmBtn) {
      const upsell = confirmBtn.closest('.pl-autoship-upsell');
      const selectedBtn = upsell.querySelector('.pl-autoship-upsell__freq-btn.is-selected');
      const itemKey = upsell.dataset.itemKey;
      const itemQty = parseInt(upsell.dataset.itemQty, 10) || 1;

      if (!selectedBtn) return;

      const sellingPlanId = parseInt(selectedBtn.dataset.sellingPlanId, 10);
      const freqName = selectedBtn.querySelector('.pl-autoship-upsell__freq-name')?.textContent.trim();
      const subPrice = selectedBtn.querySelector('.pl-autoship-upsell__freq-price')?.textContent.trim();

      if (!sellingPlanId) return;

      /* Build rich payload once for both events */
      const payload = buildUpsellPayload(upsell, selectedBtn);

      confirmBtn.disabled = true;
      confirmBtn.textContent = 'Updating…';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: itemKey,
          selling_plan: sellingPlanId,
          quantity: itemQty,
        }),
      })
        .then((res) => {
          if (!res.ok) throw new Error('Cart update failed');
          return res.json();
        })
        .then((cartData) => {
          /* Original cart-upgrade event — keep for funnel analysis */
          plTrack('pl_autoship_converted', {
            item_key: itemKey,
            variant_id: upsell.dataset.variantId,
            selling_plan_id: sellingPlanId,
            selling_plan_name: freqName,
          });

          /* Flag for post-checkout attribution */
          flagPendingConversion(payload);

          /* Show success state */
          closePanel(upsell);
          const success = upsell.querySelector('.pl-autoship-upsell__success');
          if (success) {
            const txt = success.querySelector('.pl-autoship-upsell__success-text');
            if (txt) txt.textContent = `Autoship activated — ${freqName} · ${subPrice}`;
            success.hidden = false;
          }

          /* Update subtotal if Minimog doesn't catch it */
          const subtotalEl = document.querySelector(
            '.m-cart__subtotal-price, .m-mini-cart__subtotal .m-price, [data-cart-subtotal]'
          );
          if (subtotalEl && cartData.total_price) {
            subtotalEl.textContent = (cartData.total_price / 100).toLocaleString('en-US', {
              style: 'currency',
              currency: cartData.currency,
            });
          }

          /* Trigger Minimog cart refresh */
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        })
        .catch((err) => {
          console.error('[PL Autoship]', err);
          confirmBtn.disabled = false;
          confirmBtn.textContent = 'Confirm Autoship';
          alert('Something went wrong. Please try again.');
        });

      return;
    }

    /* Cancel / No thanks button */
    const cancelBtn = e.target.closest('.pl-autoship-upsell__cancel');
    if (cancelBtn) {
      const upsell = cancelBtn.closest('.pl-autoship-upsell');
      setMode(upsell, 'onetime');
      return;
    }
  }

  /* ── Attach delegated listener to Minimog's cart drawer ── */
  function attachListener() {
  if (window.__plAutoshipListenerAttached) return;

  window.__plAutoshipListenerAttached = true;

  document.addEventListener('click', handleClick);
}

  

  /* ── MutationObserver: impression tracking + freq row scroll init ── */
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        const upsells = node.matches?.('.pl-autoship-upsell')
          ? [node]
          : [...(node.querySelectorAll?.('.pl-autoship-upsell') || [])];

        upsells.forEach(function (upsell) {
          if (upsell.dataset.plImpression) return;
          upsell.dataset.plImpression = 'true';
          plTrack('pl_autoship_impression', {
            item_key: upsell.dataset.itemKey,
            variant_id: upsell.dataset.variantId,
          });
        });

        const rows = node.matches?.('.pl-autoship-upsell__freq-row')
          ? [node]
          : [...(node.querySelectorAll?.('.pl-autoship-upsell__freq-row') || [])];
        rows.forEach(initFreqRow);
      });
    });
  });

document.addEventListener('DOMContentLoaded', () => {
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
  /* ── Post-checkout conversion matcher ──
     Called from the Shopify order status page Additional Scripts.
     Matches order line items against sessionStorage flags set when the
     customer accepted the upsell in the cart drawer, and fires the true
     post-checkout conversion event. */
  window.PL = window.PL || {};
  window.PL.matchAutoshipConversions = function (order) {
    if (!order || !Array.isArray(order.line_items)) return;

    let pending;
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      pending = raw ? JSON.parse(raw) : {};
    } catch { return; }

    if (!Object.keys(pending).length) return;

    const orderInfo = {
      order_id: order.id || order.order_id,
      order_name: order.name || order.order_name,
      order_total: order.total_price || order.total
    };

    order.line_items.forEach(li => {
      const planId = li.selling_plan_id || (li.selling_plan && li.selling_plan.id);
      if (!planId) return;
      const flag = pending[planId];
      if (!flag) return;

      /* Push GA4 event flattened for GTM Data Layer Variables */
      window.dataLayer = window.dataLayer || [];
      const flat = { event: 'pl_autoship_upsell_converted' };
      Object.keys(flag).forEach(k => { flat['upsell_' + k] = flag[k]; });
      Object.keys(orderInfo).forEach(k => { flat['upsell_' + k] = orderInfo[k]; });
      window.dataLayer.push(flat);

      /* Klaviyo */
      window._learnq = window._learnq || [];
      window._learnq.push(['track', 'Autoship Upsell Converted', { ...flag, ...orderInfo }]);

      delete pending[planId];
    });

    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pending)); } catch {}
  };

  /* ── Init ── */
document.addEventListener('DOMContentLoaded', attachListener);

  /* ── Expose for manual re-init if needed ── */
  window.PLAutoshipUpsell = { attachListener, updateScrollShadows };

})();